// src/api/userAPI.js
import { updatePassword } from 'firebase/auth';
import axiosInstance from '../utils/axios';

const userAPI = {
    // CREATE
    createUser: (data) => axiosInstance.post('/users/add', data),

    // READ
    getUsers: () => axiosInstance.get('/users/list'),
    getCourierActive: (params) => axiosInstance.get('/users/list', { params: params }),
    getCourierInactive: (params) => axiosInstance.get('/users/list', { params: params }),
    getCourier: (params) => axiosInstance.get('/users/list', { params: params }),
    getUserAdmin: (params) => axiosInstance.get('/users/list', { params: params }),
    getUserSummary: () => axiosInstance.get('/users/summary'),
    getUserById: (id) => axiosInstance.get(`/users/view/${id}`),

    // UPDATE
    updateUser: (id, data) => axiosInstance.put(`/users/update/${id}`, data),
    updatePassword: (id, data) => axiosInstance.put(`/users/update/${id}`, data),

    // DELETE
    deleteUser: (id) => axiosInstance.delete(`/users/delete/${id}`),

    // GET ROLES
    getRoles: (params) => axiosInstance.get('/roles/list', { params: params }),
    getRoleUser: () => axiosInstance.get(`/users/roles`),
};

export default userAPI;
